import { WarningCircle } from '@phosphor-icons/react';

import { useClassHelper } from '../../../../../hooks/useClassHelper';
import { componentName } from '../constants';
import { IValues } from '../types';
import { Paragraph } from './shared/Paragraph';

interface Props {
  title: string;
  details: string;
  themeValues: IValues;
}

/**
 * PSAP feedback alert — shows the carrier's `error_details` from a VoWiFi 422
 * VERBATIM above the address form (UES-11807, Figma 2481-970): warning icon +
 * red message, no visible heading. `title` only becomes the accessible name
 * of the alert — not portal-configurable here (the visible "Address Help"
 * heading on the Confirmation error face is, via its own address_help_label).
 */
export const AddressHelpBox = ({ title, details, themeValues }: Props) => {
  const c = useClassHelper(componentName);

  return (
    <div
      role="alert"
      aria-live="polite"
      aria-label={title}
      className={c('__address-help')}
      data-testid="vowifi-address-help"
    >
      <WarningCircle size={20} aria-hidden="true" />
      <Paragraph
        fontFamily={themeValues.fontParagraph}
        className={c('__address-help-details')}
      >
        {details}
      </Paragraph>
    </div>
  );
};
